
    import { mapGetters } from 'vuex';

    export default {
        name: 'JobViewPills',

        computed: {
            ...mapGetters('job', {
                $_jobTypeLabel: 'jobTypeLabel',
                $_contractTypeLabel: 'contractTypeLabel',
            }),
        },
    };
